// extracted by mini-css-extract-plugin
export var gradient = "CtxHeroSection-module--gradient--57d61";
export var hero = "CtxHeroSection-module--hero--08c93";
export var heroContent = "CtxHeroSection-module--heroContent--0291f";
export var heroFigure = "CtxHeroSection-module--heroFigure--2250d";
export var heroMedia = "CtxHeroSection-module--heroMedia--e8dfb";
export var heroPicture = "CtxHeroSection-module--heroPicture--9757c";
export var noGradient = "CtxHeroSection-module--noGradient--afaa7";